import { memo, useEffect, useState } from "react";
import { usePlayGif } from "../Stores/useGif";
import { useSelector } from "react-redux";
import confetti from "canvas-confetti";

export const PlayGif = memo(() => {
  const { gifSrc, setShowGif } = usePlayGif();
  const [currentGifSrc, setCurrentGifSrc] = useState("");
  const state = useSelector((state) => state.reducer);

  useEffect(() => {
    if (!gifSrc || gifSrc.length === 0) return;

    const randomGif = gifSrc[Math.floor(Math.random() * gifSrc.length)];
    const img = new Image();
    img.src = randomGif;

    let confettiInterval;
    let hideTimer;

    const onLoad = () => {
      // 1) Show the GIF
      setCurrentGifSrc(randomGif);

      // 2) Fire confetti 3 times
      let count = 0;
      confettiInterval = window.setInterval(() => {
        if (state.isNo > 0) {
          confetti({
            particleCount: 120,
            spread: 100,
            origin: { y: 0.6 },
          });
        }
        count++;
        if (count >= 3) {
          clearInterval(confettiInterval);
        }
      }, 500);

      // 3) Hide the modal after 4 seconds
      hideTimer = window.setTimeout(() => {
        setShowGif(false);
      }, 4000);
    };

    img.addEventListener("load", onLoad);

    return () => {
      img.removeEventListener("load", onLoad);
      clearInterval(confettiInterval);
      clearTimeout(hideTimer);
    };
  }, [gifSrc, state.isNo, setShowGif]);

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-30">
      <div className="relative rounded-3xl p-6 border-4 border-yellow-400 bg-gradient-to-br from-yellow-100 via-white to-yellow-50 shadow-2xl max-w-md w-full overflow-visible">
        {currentGifSrc && (
          <img
            src={currentGifSrc}
            alt="Reward animation"
            className="mx-auto rounded-xl max-w-xs drop-shadow-lg animate-scale-bounce"
          />
        )}
        <div className="mt-4 text-2xl font-extrabold text-yellow-600 drop-shadow-lg animate-bounce tracking-wide uppercase text-center">
          🎉 {state.badgegif} 🎉
        </div>
      </div>
    </div>
  );
});
